<template>
    <div class="col-6 col-sm-4 col-lg-3 px-sm-3">
        <router-link :to="{name: 'post', params: { slug: post.slug }}" class="text-decoration-none">
            <div class="card card-renault card-renault-sombra">
                <div
                    class="card-image z-1"
                    v-if="post.coverImageThumb"
                    :style="{
                        'background-image': 'url(' + post.coverImageThumb + ')',
                        'background-position': post.coverImageAlignment,
                        'background-size': post.coverImageSizing,
                    }"
                ></div>
                <!-- Blurred backdrop image -->
                <div
                    class="card-image-backdrop z-0"
                    :style="{
                        'background-image': 'url(' + post.coverImageThumb + ')',
                    }"
                ></div>
                <div class="card-body z-1">
                    <small
                        v-if="post.categories.length > 0 && !post.categories.find(cat => { return cat.slug === 'producto' })"
                        class="d-inline-block fw-600 me-2"
                    >
                        {{ post.categories[0].full_name }}
                    </small>
                    <p class="card-title" v-if="!post.categories.find(cat => { return cat.slug === 'producto' })">
                        {{ formatDate(post.published_at) }}
                    </p>
                    <h2 class="card-text mb-2">
                        {{ post.title }}
                    </h2>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        post: Object,
    },
    mounted() {
        
    },
    methods: {
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("es", options);
        },
    },
};
</script>
